// icons
import { ReactComponent as TurkeyIcon } from '../assets/svg/country-flags/turkey.svg';
import { ReactComponent as UnitedArabIcon } from '../assets/svg/country-flags/united-arab.svg';
import { ReactComponent as CanadaIcon } from '../assets/svg/country-flags/canada.svg';
import { ReactComponent as OmanIcon } from '../assets/svg/country-flags/oman.svg';
import { ReactComponent as SaudiArabiaIcon } from '../assets/svg/country-flags/saudi-arabia.svg';
import authWallpaperOM from "../assets/images/base/auth-wallpaper-om.png";
import authWallpaperSA from "../assets/images/base/auth-wallpaper-sa.png";


export const defaultAuthWallpaper = authWallpaperOM;


export const countries = [
  {
    label: '+968',
    country: 'Oman',
    country_code: 'OM',
    code: `+968`,
    icon: OmanIcon,
    length: 8,
    authWallpaper: authWallpaperOM
  },
  {
    label: `+966`,
    country: 'Saudi Arabia',
    country_code: 'SA',
    code: `+966`,
    icon: SaudiArabiaIcon,
    length: 9,
    authWallpaper: authWallpaperSA
  },
  {
    label: `+971`,
    country: 'United Arab Emirates',
    country_code: 'AE',
    code: `+971`,
    icon: UnitedArabIcon,
    length: 9
  },
  {
    label: `+90`,
    country: 'Turkey',
    country_code: 'TUK',
    code: `+90`,
    icon: TurkeyIcon,
    length: 9
  },
  {
    label: `+1`,
    country: 'Canada',
    country_code: 'CA',
    code: `+1`,
    icon: CanadaIcon,
    length: 10
  }
];
